export const TestPaths = {
    testData: "/test_data",
    estimatedBehavior: "/estimated_behavior"
};
